import { render, staticRenderFns } from "./QueryCriteria.vue?vue&type=template&id=bc870148&"
import script from "./QueryCriteria.vue?vue&type=script&lang=js&"
export * from "./QueryCriteria.vue?vue&type=script&lang=js&"
import style0 from "./QueryCriteria.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports